import { EncodingTool } from "../../../components/developerTools/EncodingTool";
import { ToolLayout } from "../../../components/developerTools/ToolLayout";



/** Displays the local UTF-8 Base64 encoder and decoder. */
export const Base64Tool = () => (
	<ToolLayout title="Base64 Encoder & Decoder" description="Convert UTF-8 text to and from Base64 for use in text-based systems." local>
		<EncodingTool format="base64" />
	</ToolLayout>
);
